import type { MfgRecipeKind } from "./types";

export const MFG_RECIPE_KIND_OPTIONS: Array<{ id: MfgRecipeKind; label: string }> = [
  { id: "assembly", label: "Assembly (sub-build)" },
  { id: "variant", label: "Variant (material delta / swap)" },
  { id: "option", label: "Option (single-feature swap)" },
  { id: "package", label: "Package (bundle of options)" },
  { id: "product", label: "Product (top-level SKU)" },
];

export const MFG_BOM_KIND_FILTERS: Array<{ id: MfgRecipeKind | "all"; label: string }> = [
  { id: "all", label: "All" },
  ...MFG_RECIPE_KIND_OPTIONS.map((o) => ({ id: o.id, label: o.label.split(" (")[0] ?? o.label })),
];
